import React from "react";
import Transaction from "../components/Transactions/TransactionsPage";
import { Headers } from "../components/ui/heading";
import { Paper } from "@mantine/core";

function Transactions() {
  return (
    <div className="min-h-screen flex flex-col pb-16">
      <Paper shadow="xs" p="xl">
        <div className="mb-4 flex-shrink-0">
          <Headers name="Transactions" />
        </div>
        <div className="flex-1">
          <Transaction />
        </div>
      </Paper>
    </div>
  );
}

export default Transactions;
